import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-yellow-500/10 border border-yellow-500/20 flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        <p className="text-xs font-mono tracking-[0.3em] text-muted-foreground uppercase mb-2">
          Payment Cancelled
        </p>
        <h1 className="text-3xl font-black uppercase text-white mb-3">
          No charge made.
        </h1>
        <p className="text-muted-foreground mb-8">
          Your payment was cancelled. Nothing was charged to your card.
        </p>

        <div className="flex gap-3 justify-center">
          <Button asChild variant="outline" className="border-white/20 hover:bg-white/5">
            <Link href="/">Back to Home</Link>
          </Button>
          <Button asChild className="bg-primary text-primary-foreground">
            <Link href="/marketplace">Try Again</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
